import { IonChip, IonIcon, IonLabel, IonSkeletonText, useIonModal } from "@ionic/react";
import { useRfidProfileQuery } from "../query/rfidProfileQuery";
import RfidProfileModal from "../modals/RfidProfileModal";
import { modalController } from "@ionic/core";
import { getRfidDisplayLabel } from "../utils/rfidDisplay";

interface RfidChipProps {
    rfidCode: string,
    deviceId?: string
}

const RfidChip: React.FC<RfidChipProps> = ({ rfidCode, deviceId }) => {
    const query = useRfidProfileQuery(rfidCode, deviceId);
    const [presentProfile, dismissProfile] = useIonModal(RfidProfileModal, { 
        dismiss: (data: string, role: string) => dismissProfile(data, role),
        rfidCode
    });

    const openProfile = (e: any) => {
        console.log('Open profile for RFID:', rfidCode);

        (async () => {
            presentProfile({
                presentingElement: await modalController.getTop() || document.getElementsByTagName('ion-router-outlet')[0]
            });
        })();

        e.stopPropagation();
        e.preventDefault();
        return false;
    }

    const isNamed = !!query.data?.label?.trim();

    return (
        <IonChip key={rfidCode} color={isNamed ? 'primary' : 'dark'} onClick={openProfile}>
            <IonIcon src="/assets/rfid/tag-simple.svg" aria-hidden />
            {query.isLoading
                ? <IonLabel><IonSkeletonText style={{ width: '42px' }} animated /></IonLabel>
                : <IonLabel>{getRfidDisplayLabel(rfidCode, query.data?.label)}</IonLabel>}
        </IonChip>
    );
};

export default RfidChip;
